import { FC } from 'react';
import useStrategicImperativeCreate from './StrategicImperativeForm.hook';
import FormContainer from 'modules/maya/components/FormContainer/FormContainer';
import { StrategicImperativeFormPropsType } from 'modules/maya/components/StrategicImperativeForm/StrategicImperativeForm.types';
import Box from 'yoda-ui/Box';
import SelectYoda from 'yoda-ui/Form/SelectYoda';
import TextYoda from 'yoda-ui/Form/TextYoda';
import { YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

const StrategicImperativeForm: FC<StrategicImperativeFormPropsType> = ({
  strategicImperative,
  submitCallback,
  cancelCallback,
}) => {
  const {
    strategicImperativeFormConfig,
    providerFields,
    cancelButtonConfig,
    submitButtonConfig,
  } = useStrategicImperativeCreate(strategicImperative, submitCallback, cancelCallback);
  const width50 = 'calc(50% - 20px)';

  return (
    <FormContainer providerFields={ providerFields } cancelButtonConfig={ cancelButtonConfig } submitButtonConfig={ submitButtonConfig } >
      <Box>
        <TextYoda { ...strategicImperativeFormConfig.title } />
      </Box>

      <Box justifyContent={ YodaJustifyContent.spaceBetween } display={ 'flex' }>
        <Box paddingTop={ YodaSpacing.large } width={ width50 }>
          <SelectYoda { ...strategicImperativeFormConfig.therapeuticArea } />
        </Box>
        <Box paddingTop={ YodaSpacing.large } width={ width50 }>
          <TextYoda { ...strategicImperativeFormConfig.year } />
        </Box>
      </Box>

      <Box paddingTop={ YodaSpacing.large }>
        <TextYoda { ...strategicImperativeFormConfig.description } />
      </Box>
    </FormContainer>
  );
};

export default StrategicImperativeForm;
